import styled from 'styled-components';

export const Container = styled.div`
  .row-skeleton {
    height: 24px;
    width: 80%;
  }

  .row-skeleton.description {
    height: 12px;
    width: 100%;
    max-width: 100px;
  }

  .row-skeleton.title {
    height: 40px;
  }

  .row-skeleton.action {
    height: 12px;
    width: 100%;
    max-width: 120px;
  }

  .row-skeleton.button {
    height: 35px;
    max-width: 113px;
    border-radius: 8px;
  }
`;
